/*
 * The slats a wooden pallet is assembled from: a thin top deck of boards with
 * gaps, three lengthwise stringers, and a thin bottom deck — a recognizable
 * EUR-style pallet regardless of footprint size. Every slat is the
 * `Primitive-Cube100x100x100cm` primitive scaled to size.
 *
 * That primitive's origin is on its TOP face, not its centre: the mesh spans
 * local y ∈ [-1, 0]. A slat at `position.y` with `scale.y = h` therefore fills
 * y ∈ [position.y - h, position.y], and its position IS its top surface. Place
 * slats by their top edge accordingly — centring them (position = top - h/2)
 * lifts each one by half its own height, which is what once left the top deck
 * hovering above the stringers and the bottom deck buried inside them.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var palletBoardThickness = 0.025;
export var palletBlockHeight = 0.08;
/* The pallet's total height, top deck to bottom deck. */
export var palletHeight = 2 * palletBoardThickness + palletBlockHeight;
/*
 * Boards spanning the full width, spread along the length with equal gaps
 * (board, gap, board, …), their top surface at `topY`.
 */
var buildDeck = function (count, length, width, topY) {
    var segments = count * 2 - 1;
    var boardLength = length / segments;
    return Array.from({ length: count }, function (_, i) { return ({
        scale: [boardLength, palletBoardThickness, width],
        position: [-length / 2 + boardLength / 2 + i * 2 * boardLength, topY, 0],
    }); });
};
/*
 * Local slat transforms relative to the pallet root, which is placed at the
 * bottom of the lowest layer of boxes. The top deck's top surface is at local
 * y = 0 and the pallet body extends downward, so the stack rests on it.
 */
export var buildPalletSlats = function (length, width) {
    var t = palletBoardThickness;
    var bh = palletBlockHeight;
    var topDeck = buildDeck(6, length, width, 0);
    // Stringers: three lengthwise beams between the decks (left, centre, right).
    var stringerWidth = Math.min(0.12, width * 0.18);
    var stringers = [
        -width / 2 + stringerWidth / 2,
        0,
        width / 2 - stringerWidth / 2,
    ].map(function (z) { return ({
        scale: [length, bh, stringerWidth],
        position: [0, -t, z],
    }); });
    var bottomDeck = buildDeck(3, length, width, -(t + bh));
    return __spreadArray(__spreadArray(__spreadArray([], __read(topDeck), false), __read(stringers), false), __read(bottomDeck), false);
};
